module.exports = __webpack_public_path__ + "img/Engagement_02_what.58c946d7.jpg";